<template>
  <section class="prices-horizontal container">
    <ul v-show="!isLoading">
      <li
        v-for="(
          {
            name = '',
            description = '',
            currencySymbol = '',
            cost = 0,
            costDescription = '',
            originalCostWithoutDiscount = 0,
            discount = 0,
            upgrade = false,
            specs = [],
            borderColor = '',
            hasFreeTrial = false
          },
          index
        ) in parsedPrices"
        :key="index"
      >
        <Horizontal
          :name="name"
          :description="description"
          :currency-symbol="currencySymbol"
          :price="cost"
          :price-description="costDescription"
          :original-cost-without-discount="originalCostWithoutDiscount"
          :discount="discount"
          :upgrade="upgrade"
          :specs="specs"
          :primary-color="primaryColor"
          :secondary-color="secondaryColor"
          :terciary-color="terciaryColor"
          :background-image="backgroundImage.url"
          :quaternary-color="quaternaryColor || borderColor || ''"
          :button-text="
            getFreeTrialButtonText(hasFreeTrial, buttonTextFreeTrial, buttonText) ||
            $t('purchase.plans.common.suscribe')
          "
          :icon-image="icon.url"
          @subscribe="$emit('subscribe', { price: prices[index] })"
        />
      </li>
      <li class="d-flex justify-content-center">
        <BottomContent :href="bottomLink" :text="bottomText" :primary-color="terciaryColor">
          <slot name="bottom-content"></slot>
        </BottomContent>
      </li>
    </ul>
    <Loading v-show="isLoading" />
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  components: {
    Horizontal: () => import('@/components/Prices/Horizontal'),
    Loading: () => import('UI/Loading'),
    BottomContent: () => import('@/components/Prices/PricesHorizontal/BottomContent')
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    bottomText: {
      type: String,
      required: true
    },
    bottomLink: {
      type: String,
      required: true
    },
    backgroundImage: {
      type: Object,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    icon: {
      type: Object,
      required: true
    },
    secondaryColor: {
      type: String,
      required: true
    },
    prices: {
      type: Array,
      required: true
    },
    primaryColor: {
      type: String,
      required: true
    },
    terciaryColor: {
      type: String,
      required: true
    },
    quaternaryColor: {
      type: String,
      required: true
    },
    buttonTextFreeTrial: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('plan-areas', ['getFreeTrialButtonText']),
    parsedPrices() {
      return this.prices.map((price) => {
        return {
          ...price,
          recurrent: Boolean(price.recurrent),
          costDescription: price.isMonthlyAnnualCommitment
            ? this.$t('plans.common.cards.billedMonthlyAnnualCommitment')
            : price.costDescription
        };
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.prices-horizontal {
  ul {
    list-style: none;
    padding: 0;
  }
}
</style>
